import { CoreAppState } from '../state/core-app.state';
import { BaseResourceService } from './base-resource.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { MeetingType } from '@prisma/client';
import { MeetingTypeResourceTypeMappings } from '@aa/nest/resource';
import { meetingTypeCompositeKeyOrder } from '@aa/nest/resource/objects';

@Injectable()
export class MeetingTypeService extends BaseResourceService<MeetingTypeResourceTypeMappings> {
  constructor(
    protected override readonly http: HttpClient,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(http, store, 'meeting-types');
  }
}
